// @ts-nocheck
import { IReducerAction } from "../../interfaces/IRedux";
import {
  PACKAGE_LOADING,
  PACKAGE_END_LOADING,
  PACKAGE_LOADING_OPERATION,
  PACKAGE_END_LOADING_OPERATION,
  PACKAGE_GET_DATA,
  PACKAGE_GET_ITEM,
  PACKAGE_CLEAR,
  PACKAGE_GET_ITEM_ARTICLES,
  PACKAGE_UPDATE_ARTICLE_STATUS,
  PACKAGE_DELETE_ELEMENT,
  PACKAGE_CREATE_AND_ADD,
  PACKAGE_GET_ELEMENTS,
} from "../types";

const initialState = {
  loading: false,
  loadingOperation: false,
  elements: [],
  item: null,
  itemArticles: [],
  pagination: {},
};

export default function reducer(state = initialState, action: IReducerAction) {
  const payload = action.payload || {};

  switch (action.type) {
    case PACKAGE_LOADING:
      return {
        ...state,
        loading: true,
      };

    case PACKAGE_END_LOADING:
      return {
        ...state,
        loading: false,
      };

    case PACKAGE_LOADING_OPERATION:
      return {
        ...state,
        loadingOperation: true,
      };

    case PACKAGE_END_LOADING_OPERATION:
      return {
        ...state,
        loadingOperation: false,
      };

    case PACKAGE_GET_DATA:
      // @ts-ignore
      const rows = Array.isArray(payload) ? payload : payload.rows;
      // @ts-ignore
      const pagination = payload.pagination || {};
      return {
        ...state,
        loading: false,
        elements: rows || [],
        pagination,
      };

    case PACKAGE_GET_ELEMENTS:
      return {
        ...state,
        loading: false,
        elements: Array.isArray(payload) ? payload : [],
      };

    case PACKAGE_GET_ITEM:
      if (payload && Object.keys(payload).length > 0) {
        const packageIndex = state.elements.findIndex(
          (e) => e.id === payload.id
        );
        if (packageIndex >= 0) {
          state.elements[packageIndex] = payload;
        }
      }
      return {
        ...state,
        loading: false,
        loadingOperation: false,
        item: payload,
      };

    case PACKAGE_GET_ITEM_ARTICLES:
      return {
        ...state,
        loadingOperation: false,
        itemArticles: Array.isArray(payload) ? payload : [],
      };

    case PACKAGE_UPDATE_ARTICLE_STATUS:
      const itemArticles = state.itemArticles;
      if (payload && Object.keys(payload).length > 0) {
        const findedArticleIndex = itemArticles.findIndex(
          (a) => a.id === payload.id
        );

        if (payload.remove && findedArticleIndex >= 0) {
          itemArticles.splice(findedArticleIndex, 1);

          const findedPackageIndex = state.elements.findIndex(
            (e) => e.id === payload.id_package
          );
          if (findedPackageIndex >= 0) {
            state.elements[findedPackageIndex].count_articles -= 1;
          }
        } else if (findedArticleIndex >= 0) {
          itemArticles[findedArticleIndex].status = payload.status;
        }
      }
      return {
        ...state,
        loadingOperation: false,
        itemArticles,
      };

    case PACKAGE_CREATE_AND_ADD:
      state.elements.splice(0, 0, payload);
      return {
        ...state,
        loadingOperation: false,
      };

    case PACKAGE_DELETE_ELEMENT:
      if (payload && Object.keys(payload).length > 0) {
        const packageIndex = state.elements.findIndex(
          (e) => e.id === payload.id
        );
        if (packageIndex >= 0) {
          state.elements.splice(packageIndex, 1);
        }
      }
      return {
        ...state,
        loadingOperation: false,
      };

    case PACKAGE_CLEAR:
      return initialState;
    default:
      return state;
  }
}
